import { render, staticRenderFns } from "./Langindpage.vue?vue&type=template&id=04ecb4b4"
import script from "./Langindpage.vue?vue&type=script&lang=js"
export * from "./Langindpage.vue?vue&type=script&lang=js"
import style0 from "./Langindpage.vue?vue&type=style&index=0&id=04ecb4b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports